import { Text, View } from "react-native";
import useGestionCETStyle from "./GestionCET.styles";
import type { DotationEpargnable } from "./GestionCET.types";

export default function DotationEpargnable({dotation}: DotationEpargnable){
    const { styles } = useGestionCETStyle();
    return (
        <View style={[styles.dotation, { borderLeftColor: dotation.natureAbsence?.couleurHexa }]}>
            <View style={styles.dotationColumn}>
                <Text style={styles.mainText}>Nature d'absence</Text>
                <Text>{dotation.natureAbsence?.libelle}</Text>
            </View>
            <View style={styles.dotationColumn}>
                <Text style={[styles.rightText, styles.mainText]}>Epargnable</Text>
                <Text style={styles.rightText}>{dotation.reste} {dotation.jourHeure === 1 ? "jours" : "heures"}</Text>
            </View>
        </View>
    )
}
